import React, { SyntheticEvent } from 'react';
import { Snackbar, IconButton, SnackbarCloseReason } from '@mui/material';
import { Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from '../styles/fontStyles';

interface SnackBarAlertMobileExperienceProps {
  open: boolean;
  onClose: () => void;
}

const SnackBarAlertMobileExperience: React.FC<SnackBarAlertMobileExperienceProps> = ({ open, onClose }) => {
  const handleClose = (event: Event | SyntheticEvent<any, Event>, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  const action = (
    <IconButton
      size="medium"
      aria-label="close"
      color="inherit"
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleClose(event)}
      sx={{ p: 0.5 }}
    >
      <CloseIcon fontSize="medium" />
    </IconButton>
  );

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      sx={{
        bottom: { xs: 16, sm: 24 },
        left: '24px !important',
        right: '24px !important',
        width: '90% !important',
        margin: '0 auto',
      }}
    >
      <Alert
        severity="info"
        action={action}
        sx={{
          width: '100%',
          backgroundColor: `${colors.m3SysInverseSurface} !important`,
          color: colors.m3SysInverseOnSurface,
          '& .MuiAlert-icon': {
            display: 'none',
          },
          '& .MuiAlert-action': {
            padding: 0,
            marginTop: '16px',
            marginRight: -0.5,
          },
          boxShadow:
            '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
        }}
      >
        This page looks better on a larger screen. <br /> For the best experience, try viewing it on a desktop or
        tablet.
      </Alert>
    </Snackbar>
  );
};

export default SnackBarAlertMobileExperience;
